import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { stockOnHandUrl } from "@saleor/stockOnHand/url";
import ReportStockOnHandPage from "@saleor/stockOnHand/views/ReportStockOnHandPage";
import {
  StockOnHandSort,
  StockOnHandSortField
} from "@saleor/stockOnHand/views/ReportStockOnHandPage/sort";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router";

const StockOnHandSection = () => {
  const intl = useIntl();

  const StockOnHandComponent: React.FC<RouteComponentProps<any>> = ({
    location
  }) => {
    const qs = parseQs(location.search.substr(1));
    const params: StockOnHandSort = asSortParams(
      qs,
      StockOnHandSortField,
      StockOnHandSortField.customer,
      false
    );
    return <ReportStockOnHandPage params={params} />;
  };

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.inquiry5Admin)} />
      <Switch>
        <Route exact path={stockOnHandUrl} render={StockOnHandComponent} />
      </Switch>
    </>
  );
};

export default StockOnHandSection;
